<template>
  <v-app>
    <internal-core-app-bar v-model="expandOnHover" />

    <!-- <internal-core-drawer :expand-on-hover.sync="expandOnHover" /> -->

    <internal-core-view />

    <!-- <internal-core-settings v-model="expandOnHover" /> -->

    <!-- <internal-core-footer /> -->
  </v-app>
</template>

<script>
export default {
  name: "internalIndex",

  components: {
    internalCoreAppBar: () => import("./AppBar"),
    // internalCoreDrawer: () => import("./Drawer"),
    // internalCoreSettings: () => import("./Settings"),
    internalCoreView: () => import("./View"),
    // internalCoreFooter: () => import("./Footer"),
  },

  data: () => ({
    expandOnHover: false,
  }),
};
</script>
